import React, { useEffect, useState,  useRef } from "react";
import Header from "../components/global/Header";
import LeftNavbar from "../components/global/LeftNavbar";
import CampaignRightModal from "../components/campaign/CampaignRightModal"; 
import FilterCampaign from "../components/campaign/FilterCampaign";
import CampaignTab from "../components/campaign/CampaignTab";
import { useNavigate, Link ,useLocation } from 'react-router-dom';
import {  useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import Constants from "../Constants";
import { TourProvider } from "@reactour/tour";
import $ from "jquery";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import "@reactour/popover/dist/index.css";
import steps from "../services/tourJson/campaigns";
import { Breadcrumb } from "../components/dashboard/Breadcrumb";
import { getAxiosResponse } from "../services/authApiRoutes/APImethods";
import APIUrls from "../services/APIUrls";
const Campaign = (prop) => {
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const {search} = useLocation();
  const searchKey = new URLSearchParams(search).get('id');
  const [activeTab, setActiveSection] = useState("campaigns");
  const ReduxCampaignId = useSelector((state) => state.updateCampaignId?.campaign_id?.value);
  const [allCampaignStatus, updateCampaignStatusData] = useState([]);
  const [searchText, setSearchText] = useState(searchKey);

  const closeRightModal = () =>{
    document.body.classList.remove("modal-open");
     $('#row-'+ReduxCampaignId+' a').trigger('focus')
  }
  useEffect(() => {
    document.title = "OPAL-Marketing | The Marketing Globalization Platform - Campaigns";
  },[]);
  useEffect(() => {
    $('.lastdisable').trigger('focus');
  }, []);

  useEffect(() => {
    if(searchKey !== null && searchKey !== undefined && searchKey !== ''){
      setSearchText(searchKey);
    }
  },[searchKey]);

  const getPermissions = useSelector(
    (rolePermissionSelected) => rolePermissionSelected.role_permission,
  ).value;

  const navProjectPage = (event) => {
    navigate('/dashboard')
  }
 

 const createProject = (event) =>{
    navigate("/createProject");
 }

 const createCampaign = (event) =>{
  navigate("/new-campaign");
}

  const filterFunction = () => {
    var element = document.getElementById("filterBtn");
    var element2 = document.getElementById("activeId");
    element.classList.toggle("show-flex");
    element2.classList.toggle("active");

    if (  $('#activeId').attr('aria-expanded')=== 'true'){
      $('#activeId').attr('aria-expanded','false');
    }
    else{
      $('#activeId').attr('aria-expanded','true');
    }

  };
  const scrollRef = useRef(null);
//Tutorial Tips start
function doArrow(position, verticalAlign, horizontalAlign) {
  if (!position) {
    return {};
  }
 const width = 16;
  const height = 12;
  const color = "white";
  const isVertical = position === "top" || position === "bottom";
  const spaceFromSide = 10;

  const obj = {
    [`--rtp-arrow-${
      isVertical ? opositeSide[horizontalAlign] : verticalAlign
    }`]: height + spaceFromSide + "px",
    [`--rtp-arrow-${opositeSide[position]}`]: -height + 2 + "px",
    [`--rtp-arrow-border-${isVertical ? "left" : "top"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${isVertical ? "right" : "bottom"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${position}`]: `${height}px solid ${color}`
  };
  return obj;
}
const styles = {
  popover: (base, state) => {
   return {
      ...base,
     ...doArrow(state.position, state.verticalAlign, state.horizontalAlign),
     '--reactour-accent': '#154da1',
     };
  }
  
};
const opositeSide = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right"
};
const prevButton= ({ currentStep, setCurrentStep, steps }) => {
  const first = currentStep === 0
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).trigger('focus')
  $(`.tutorial-left-arr + div button`).each(
    function(index, item){
      $(item).attr('aria-label','Go to step ' + (index + 1))
    }
  )
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).attr('aria-label','current step '+ (parseInt(currentStep,10) + 1))
  return (
    <button aria-label="go to previous" disabled={first ? "disabled" : ""} className={first ? "tutorial-left-arr tutorial-disable" : "tutorial-left-arr"}
      onClick={() => {
        if (first) {
          setCurrentStep((s) => steps.length - 1)
        } else {
          setCurrentStep((s) => s - 1)
        }
      }}
    >
      <svg viewBox="0 0 18.4 14.4"><path d="M1.4 7.2h16M7.6 1L1.4 7.2l6.2 6.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10"></path></svg>
    </button>
  )
 };
 const nextButton= ({ currentStep, setCurrentStep, steps, stepsLength, setIsOpen }) => {
  const last = currentStep === stepsLength - 1
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).trigger('focus')
  $(`.tutorial-left-arr + div button`).each(
    function(index, item){
      $(item).attr('aria-label','Go to step ' + (index + 1))
    }
  )
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).attr('aria-label','current step '+ (parseInt(currentStep,10) + 1))
  return (
    <>
    {last ? (
      <button className="finish-btn"
        onClick={() => {
        if (last) {
          setIsOpen(false)
        } else {
          setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
        }
       }}
      >Finish</button>
    ) : (
      <button aria-label="go to next" disabled={last ? "disabled" : ""} className={last ? "tutorial-right-arr tutorial-disable" : "tutorial-right-arr"}
      onClick={() => {
        if (last) {
          setIsOpen(false)
        } else {
          setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
        }
       }}
      >
      <svg viewBox="0 0 18.4 14.4"><path d="M17 7.2H1M10.8 1L17 7.2l-6.2 6.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10"></path></svg>
      </button>
    )}
    </>
  )

 }
const disableBody = (target) => disableBodyScroll(target)
const enableBody = (target) => enableBodyScroll(target)
const CampaignModelTutorial = () =>{
 document.body.classList.add("modal-open-3");
 $(".nextFocus3").on("keydown", function (e) {
  if (e.key === Constants.TAB) {
    if (e.shiftKey === false) {
      e.preventDefault();
      $(".cancelFocus3").trigger("focus");
    }
  }
});
setTimeout(() => {
  $(".cancelFocus3").trigger("focus");
  $(".cancelFocus3").on("keydown", function (e) {
    if (e.key === Constants.TAB) {
      if (e.shiftKey === true) {
        e.preventDefault();
        $(".nextFocus2").trigger("focus");
      }
    }
  });
  $(".inner-lightbox-panel").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      document.body.classList.remove("modal-open-3");
      $('.focusAdd').trigger('focus');
      $('.tutorial-tips').removeClass('focusAdd');
    }
  });
}, 500);
}
//Tutorial Tips end
const crumbs = [
    {label:'Campaigns', url:''}
 ];
let allStatus=[];
 useEffect(()=>{
  getAxiosResponse(
    APIUrls.WORKSPACE_STATUS_COUNT +
      `?campaignOwner=${false}&onlyMember=${false}`
  )
    .then((res) => {
      if (res.data.status === "success") {
        var keys = Object.keys(res.data.data);
        var values = Object.values(res.data.data);
        keys.map((key, index) => {
          allStatus.push({
            label: translate(`campaign_page.${key.toLowerCase()}`),
            count: values[index],
            code: key.toLowerCase(),
            shortLabel:translate(`campaign_page.${key.toLowerCase()}`),
            statusKey:key?.toLowerCase(),
            value:key
          });
        });
       let campaignStatus=allStatus.sort((a,b)=>a.shortLabel.localeCompare(b.shortLabel))
        updateCampaignStatusData([{label:"Select All",value:""},...campaignStatus]);
      }
    })
 },[])


  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
       <TourProvider
          steps={steps}
          styles={styles}
          prevButton={prevButton}
          nextButton={nextButton}
          afterOpen={disableBody}
          beforeClose={enableBody}
          onClickMask={({ currentStep, steps, setIsOpen }) => {
            if (steps) {
              if (currentStep === steps.length) {
                setIsOpen(true);
               }
              }
          }}
          badgeContent={({ totalSteps, currentStep }) => currentStep + 1 + "/" + totalSteps}>
          <Header ref={scrollRef} func={CampaignModelTutorial}/>
          <LeftNavbar />
        </TourProvider>
        <section className="dashboard-content" ref={scrollRef} >
          <div id= "content" className="dashboard-wrap campaign-section" >
            <Breadcrumb crumbs={ crumbs } />
            <div className="dashboard-top flex-center">
              <div className="flex-left flex-center">
                <div className="group-btn flex-center" role="tablist">
                  <button id="projectBtn"
                  role="tab"
                  aria-label={translate('projects')}
                  aria-selected="false"
                  className="dashboard-btn" onClick={navProjectPage}>{translate('projects')}</button>
                  
                  {getPermissions.includes('CAMPAIGN_DASHBOARD') ? (
                    <button id="campaignBtn"
                    role="tab"
                    aria-label={'Current tab ' + translate('campaigns')}
                    aria-selected="true"
                    className="active dashboard-btn">{translate('campaigns')}</button>
                  ) : null}

                </div>
                <div className="filter">
                  <button
                    id="activeId"
                    className="dashboard-btn"
                    onClick={()=>filterFunction()}
                    aria-expanded={false}
                    campaign-tour="filter"
                    
                  >
                    <span className="filter-icon">
                      <svg
                        width="19"
                        height="14"
                        viewBox="0 0 19 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.5627 4.00922H7.56233C7.32684 4.00922 7.125 3.64384 7.125 3.21755C7.125 2.79127 7.32684 2.42589 7.56233 2.42589H18.5627C18.7982 2.42589 19 2.79127 19 3.21755C19 3.64384 18.7982 4.00922 18.5627 4.00922Z"
                          fill="#1D4ED8"
                        />
                        <path
                          d="M2.99075 3.649H0.607496C0.280383 3.649 0 3.36861 0 3.0415C0 2.71439 0.280383 2.43401 0.607496 2.43401H2.99075C3.31786 2.43401 3.59824 2.71439 3.59824 3.0415C3.59824 3.36861 3.36459 3.649 2.99075 3.649Z"
                          fill="#1D4ED8"
                        />
                        <path
                          d="M5.37429 6.03238C3.73873 6.03238 2.38354 4.6772 2.38354 3.04164C2.38354 1.40607 3.73873 0.0508881 5.37429 0.0508881C7.00986 0.0508881 8.36504 1.40607 8.36504 3.04164C8.36504 4.6772 7.05659 6.03238 5.37429 6.03238ZM5.37429 1.26588C4.39295 1.26588 3.59854 2.0603 3.59854 3.04164C3.59854 4.02298 4.39295 4.81739 5.37429 4.81739C6.35563 4.81739 7.15005 4.02298 7.15005 3.04164C7.15005 2.0603 6.35563 1.26588 5.37429 1.26588Z"
                          fill="#1D4ED8"
                        />
                        <path
                          d="M0.437329 9.9906L11.4377 9.9906C11.6732 9.9906 11.875 10.356 11.875 10.7823C11.875 11.2085 11.6732 11.5739 11.4377 11.5739L0.437329 11.5739C0.201844 11.5739 -3.19429e-08 11.2085 -6.92097e-08 10.7823C-1.06476e-07 10.356 0.201844 9.9906 0.437329 9.9906Z"
                          fill="#1D4ED8"
                        />
                        <path
                          d="M16.0093 10.3508L18.3925 10.3508C18.7196 10.3508 19 10.6312 19 10.9583C19 11.2854 18.7196 11.5658 18.3925 11.5658L16.0093 11.5658C15.6821 11.5658 15.4018 11.2854 15.4018 10.9583C15.4018 10.6312 15.6354 10.3508 16.0093 10.3508Z"
                          fill="#1D4ED8"
                        />
                        <path
                          d="M13.6257 7.96743C15.2613 7.96743 16.6165 9.32262 16.6165 10.9582C16.6165 12.5937 15.2613 13.9489 13.6257 13.9489C11.9901 13.9489 10.635 12.5937 10.635 10.9582C10.635 9.32262 11.9434 7.96743 13.6257 7.96743ZM13.6257 12.7339C14.607 12.7339 15.4015 11.9395 15.4015 10.9582C15.4015 9.97684 14.607 9.18242 13.6257 9.18242C12.6444 9.18242 11.8499 9.97684 11.85 10.9582C11.85 11.9395 12.6444 12.7339 13.6257 12.7339Z"
                          fill="#1D4ED8"
                        />
                      </svg>
                    </span>{" "}
                    {translate('filters')}
                  </button>
                </div>
              </div>
              <div className="flex-right">
                <button onClick={createCampaign} className="dashboard-btn">
                  <svg className="plus-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M6 1V11" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                    <path d="M1 6H11" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                  </svg>
                  {translate('new_campaign')}
                </button>
              </div>
            </div>
            <div>&nbsp;</div>
            <FilterCampaign allCampaignStatus={allCampaignStatus} setSearchText={setSearchText} searchText={searchText}/>
            <CampaignTab searchText={searchText || ''} />
          </div>
        </section>
      </div>
  {ReduxCampaignId !== '' ?
  <>
  <div className="overlay" onClick={closeRightModal}></div>
   <CampaignRightModal />
  </> 
  : ''}
     
    </div>
  );
};

export default Campaign;
